import Button from "../../../../lib/html5-software-library/src/ranj/components/buttons/Button";

export default class BracketButton extends Button {
    constructor(skin, wordWrap = false) {
        super(skin, wordWrap);

        /** @type {createjs.Text} */
        this._leadingBracket = this.skin.haakjeOpen;
        /** @type {createjs.Text} */
        this._trailingBracket = this.skin.haakjeSluiten;
        /** @type {createjs.Shape} */
        this._selectionFill = this.skin.selectionText; // The square behind the text when hovering over.
        this._textAlignment = this.skin.upLabelTextField.textAlign;

        this._selectionFillPadding = 7;

        if (!wordWrap) {
            this._disableWordWrap();
        }
    }

    setHitAreaToBounds() {
        // NOTE: Over shadowing the parent (super) method.
        const hitAreaPadding = 32;
        if (this.skin) {
            var bounds = this.skin.getBounds();
            var shape = new createjs.Shape();
            shape.graphics.beginFill("#f00").rect(bounds.x - hitAreaPadding, bounds.y - hitAreaPadding, bounds.width + hitAreaPadding * 2, bounds.height + hitAreaPadding * 2).endFill();
            this.setHitArea(shape);
        }
    };

    setLabel(label) {
        super.setLabel(label);
        switch (this._textAlignment) {
            case 'left':
                this._alignLeft();
                break;
            case 'center':
                this._alignCenter();
                break;
            case 'right':
                this._alignRight();
                break;
            default:
                throw new Error(`Unhandled text alignment: ${this._textAlignment}`);
        }

        this.setHitAreaToBounds();
    }

    _alignLeft() {
        const newTextBounds = this.skin.upLabelTextField.getBounds();
        const scaleX = (newTextBounds.width + this._selectionFillPadding) / this._selectionFill.nominalBounds.width;
        const bracketSpacing = this._leadingBracket.x - (this.skin.upLabelTextField.x + newTextBounds.x);

        this._selectionFill.x = this.skin.upLabelTextField.x - this._selectionFillPadding * .5;
        this._selectionFill.scaleX = scaleX;

        this._trailingBracket.x = this.skin.upLabelTextField.x + newTextBounds.x + newTextBounds.width + bracketSpacing * 2;
    }

    _alignCenter() {
        const newTextBounds = this.skin.upLabelTextField.getBounds();
        const scaleX = (newTextBounds.width + this._selectionFillPadding * 2) / this._selectionFill.nominalBounds.width;

        this._selectionFill.x = this.skin.upLabelTextField.x;
        this._selectionFill.scaleX = scaleX;

        this._leadingBracket.x = this.skin.upLabelTextField.x + newTextBounds.x - this._selectionFillPadding;
        this._trailingBracket.x = this.skin.upLabelTextField.x + newTextBounds.x + newTextBounds.width + this._selectionFillPadding;
    }

    _alignRight() {
        const newTextBounds = this.skin.upLabelTextField.getBounds();
        const scaleX = (newTextBounds.width + this._selectionFillPadding) / this._selectionFill.nominalBounds.width;

        this._selectionFill.x = this.skin.upLabelTextField.x + this._selectionFillPadding * .5;
        this._selectionFill.scaleX = scaleX;

        this._leadingBracket.x = this.skin.upLabelTextField.x + newTextBounds.x;
    }

    _disableWordWrap() {
        for (const textFieldName of Button.TEXTFIELDNAMES) {
            if (!this.skin.hasOwnProperty(textFieldName)) {
                continue;
            }

            const textField = this.skin[textFieldName];
            textField.lineWidth = undefined; // Disables word wrapping.
        }
    }
}